import React from 'react';
import { useTranslation } from 'react-i18next';

export function GallerySelectionOverlayBar({
  activeFiltersCount,
  selectedCount,
  visibleCount,
  stickyTop = 0,
  total = null,
  onResetFilters,
  onSelectAll,
  onOpenExport = null,
  exportLimit = null,
}) {
  const { t } = useTranslation();
  const isVisible = activeFiltersCount > 0;

  if (!isVisible)
    return null;

  const areAllVisibleSelected = visibleCount > 0 && selectedCount === visibleCount;

  return (
    <div
      className="sticky z-10 mb-3"
      style={{ top: stickyTop }}
    >
      <div className="w-full rounded-lg border border-white/30 dark:border-gray-700/40 bg-white/70 dark:bg-gray-900/60 backdrop-blur-md shadow-sm px-3 py-2">
        <div className="flex flex-wrap items-center gap-2 text-xs sm:text-sm min-h-[24px]">

          {activeFiltersCount > 0 && (
            <>
              <button
                onClick={onResetFilters}
                className="text-gray-600 hover:text-gray-800 dark:text-gray-300 dark:hover:text-gray-100 font-medium"
              >
                {t('Reset filters')}
              </button>

              <div className="w-px h-4 bg-gray-300 dark:bg-gray-700 mx-1"></div>

              <button
                onClick={onSelectAll}
                className="text-blue-600 hover:text-blue-800 dark:text-blue-300 dark:hover:text-blue-200 font-medium"
              >
                {areAllVisibleSelected ? t('Deselect all') : t('Select visible')}
              </button>
            </>
          )}

          {!onOpenExport && exportLimit && (
            <span className="ml-auto text-gray-500 dark:text-gray-400">
              {t('Export available up to {{limit}} photos: narrow the search.', { limit: Number(exportLimit).toLocaleString() })}
            </span>
          )}

          {onOpenExport && (
            <button
              type="button"
              onClick={onOpenExport}
              className="ml-auto inline-flex items-center gap-1.5 rounded-full bg-blue-600 px-3 py-1 font-semibold text-white hover:bg-blue-700"
            >
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 4v12m0 0l-4-4m4 4l4-4" />
              </svg>
              {total ? t('Export · {{count}} photos', { count: Number(total).toLocaleString() }) : t('Export')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}


